<!--
  @description 业务上线申请单
  @author xiehan
  @date 2019/01/14
-->
<template>
  <div class="serviceRequest">
    <request-note
      ref="requestNote"
      @submitRequest="getRequestForm"
      submitButtonRac="serviceRequest@submit"
      :requestTitle="$t('cloudApplication.serviceRequest')"
      :disAgreeInfo="disAgreeInfo"
      :status="status">
      <div slot="center">
        <el-row :gutter="10" style="margin-bottom: 10px;">
          <el-col :span="4">
            <div v-text="$t('cloudApplication.businessType')" class="service-title"></div>
          </el-col>
          <el-col :span="5">
            <div v-text="$t('cloudApplication.group')" class="service-title"></div>
          </el-col>
          <el-col :span="5">
            <div v-text="$t('cloudApplication.versionType')" class="service-title"></div>
          </el-col>
          <el-col :span="4">
            <span style="color: red;">*</span>
            <div v-text="$t('cloudApplication.versionNum')" class="service-title"></div>
          </el-col>
          <el-col :span="6">
            <span style="color: red;">*</span>
            <div v-text="$t('cloudApplication.releaseTime')" class="service-title"></div>
          </el-col>
          <!-- <el-col :span="3">
            <el-button icon="icon-xinzeng"
              type="primary"
              style="width: 70px;"
              @click="addService"></el-button>
          </el-col> -->
        </el-row>
        <el-form ref="serviceForm" :model="serviceForm" input-width="120px" label-width="0">
          <el-row :gutter="10" v-for="(item, index) in serviceForm.serviceList" :key="item.itemKey">
            <el-col :span="4">
              <el-form-item>
                <g-select v-model="item.businessType" :list="select_businessType"></g-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item input-width="150px">
                <g-select v-model="item.group" :list="select_group"></g-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item input-width="150px">
                <g-select v-model="item.versionType" :list="select_versionType"></g-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item
                input-width="120px"
                :prop="'serviceList.' + index + '.version'"
                :rules="[{ required: true, message: $t('common.entryTips') + $t('cloudApplication.versionNum'), trigger: 'blur' }]">
                <el-input v-model="item.version"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                :prop="'serviceList.' + index + '.releaseTime'"
                :rules="[{ required: true, message: $t('common.entryTips') + $t('cloudApplication.releaseTime'), trigger: 'blur' }]">
                <el-date-picker value-format="timestamp" style="width: 180px;" v-model="item.releaseTime" type="datetime">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="3">
              <el-button icon="icon-shanchu1"
                style="width: 70px;"
                @click="deleteService(index)"></el-button>
            </el-col> -->
          </el-row>
        </el-form>
      </div>
      <div slot="footer">
        <el-table
          v-if="status === '5'"
          :data="processTable"
          style="width: 100%">
          <el-table-column prop="operateTime" :label="$t('common.time')"></el-table-column>
          <el-table-column prop="node" :label="$t('queryworkOrder.node')"></el-table-column>
          <el-table-column prop="operator" :label="$t('queryworkOrder.operator')"></el-table-column>
          <el-table-column prop="operation" :label="$t('common.handle')"></el-table-column>
          <el-table-column prop="advise" :label="$t('queryworkOrder.advise')"></el-table-column>
        </el-table>
      </div>
    </request-note>
  </div>
</template>

<script>
  import dic from '@/components/mixins/dic'
  import requestNote from '@/views/component/requestNote/requestNote'
  import queryworkOrderBiz from '@/logic/workFlow/queryworkOrderBiz'
  import resApplicationBiz from '@/logic/workFlow/resApplicationBiz'
  import TimeFormat from '@/utils/timeFormat'
  export default {
    mixins: [dic],
    data () {
      return {
        select_businessType: {},
        select_group: {},
        select_versionType: {},
        select_operate: {},
        serviceForm: {
          serviceList: [{
            businessType: '',
            group: '',
            versionType: '',
            version: '',
            releaseTime: '',
            itemKey: new Date().getTime()
          }]
        },
        status: '1',
        disAgreeInfo: {},
        processTable: []
      }
    },
    components: {
      requestNote
    },
    methods: {
      async getDic () {
        await Promise.all([
          this.dGetDictionaryByCode('businessType'),
          this.dGetDictionaryByCode('groupType'),
          this.dGetDictionaryByCode('versiontype'),
          this.dGetDictionaryByCode('workflowOperationType')
        ])
        if (this.$route.query.status === '5') {
          this.getOrderInfo()
        }
        this.select_businessType = { ...this.dDictionary.businessType }
        this.serviceForm.serviceList[0].businessType = Object.keys(this.select_businessType)[0]
        this.select_group = { ...this.dDictionary.groupType }
        this.serviceForm.serviceList[0].group = Object.keys(this.select_group)[0]
        this.select_versionType = { ...this.dDictionary.versiontype }
        this.serviceForm.serviceList[0].versionType = Object.keys(this.select_versionType)[0]
        this.select_operate = { ...this.dDictionary.workflowOperationType }
      },
      getRequestForm (val) {
        this.$refs['serviceForm'].validate((valid) => {
          if (valid) {
            let serviceList = []
            this.serviceForm.serviceList.map(item => {
              serviceList.push({
                businessType: item.businessType,
                group: item.group,
                versionType: item.versionType,
                version: item.version,
                releaseTime: item.releaseTime
              })
            })
            let saveInfo = {
              applicant: val.applicant,
              approver: val.approver,
              cc: val.cc,
              department: val.department,
              expectedTime: val.expectedTime,
              serviceInfoVO: serviceList,
              orderType: val.orderType,
              templateId: val.orderType,
              processInstanceId: val.processInstanceId,
              reason: val.reason,
              remarks: val.remarks,
              site: val.site
            }
            resApplicationBiz.submitBusinessOnline(saveInfo).then(() => {
              this.$message({
                message: this.$t('common.success'),
                type: 'success'
              })
              this.$router.push({ name: 'cloudApplication' })
            })
          } else {
            return false
          }
        })
      },
      addService () {
        this.serviceForm.serviceList.push({
          businessType: Object.keys(this.select_businessType)[0],
          group: Object.keys(this.select_group)[0],
          versionType: Object.keys(this.select_versionType)[0],
          itemKey: new Date().getTime()
        })
      },
      deleteService (index) {
        if (this.serviceForm.serviceList.length === 1) return
        this.serviceForm.serviceList.splice(index, 1)
      },
      getOrderInfo () {
        queryworkOrderBiz.getTaskDetailById({
          processInstanceId: String(this.$route.query.orderId)
        }).then(data => {
          this.disAgreeInfo = data
          this.processTable = data.record
          this.processTable.map(item => {
            item.operateTime = TimeFormat.getFormatTime(item.operateTime)
            item.operation = this.select_operate[item.operation]
          })
          this.serviceForm.serviceList = []
          this.disAgreeInfo.info.serviceInfoVO.map((item, index) => {
            this.serviceForm.serviceList.push({
              businessType: item.businessType,
              group: item.group,
              versionType: item.versionType,
              version: item.version,
              releaseTime: item.releaseTime,
              itemKey: index
            })
          })
          this.$nextTick(() => {
            this.$refs.requestNote.onStatus5()
          })
        })
      }
    },
    watch: {
      $route (to, from) {
        if (to.name === 'serviceRequest' && from.name === 'cloudApplication') {
          this.status = '1'
          this.$nextTick(() => {
            this.$refs.requestNote.init()
          })
          this.serviceForm.serviceList = [{
            businessType: '',
            group: '',
            versionType: '',
            version: '',
            releaseTime: '',
            itemKey: new Date().getTime()
          }]
          this.getDic()
        } else if (to.name === 'serviceRequest' && from.name === 'queryworkOrder') {
          this.status = '5'
          this.getDic()
        }
      }
    },
    mounted () {
      if (this.$route.query.status === '5') {
        this.status = '5'
      }
      this.getDic()
    }
  }
</script>

<style scoped>
  .service-title {
    height: 33px;
    line-height: 33px;
    display: inline-block;
  }
</style>